export default __webpack_public_path__ + "static/media/Rede_TV.69a68e39.png";